import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexColCenter,
  FlexCol,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { DsiTextArea as TextArea } from '../General/Input';
import { TextP } from '../../Defaults/Text';

export interface Props {
  label?: string;
  marginRight?: number;
  marginBottom?: number;
  maxWidth?: number;
  required?: boolean;
  maxWidthPx?: number;
  [x: string]: any;
}

function FormTextArea({
  label,
  maxWidth = 100,
  marginRight = 0,
  marginBottom = 16,
  maxWidthPx = 688,
  required,
  ...props
}: Props) {
  return (
    <Wrapper
      marginBottom={marginBottom}
      marginRight={marginRight}
      maxWidth={maxWidth}
      maxWidthPx={maxWidthPx}
    >
      {label && (
        <Label>
          {label}
          {required && <Required>{' *'}</Required>}
        </Label>
      )}
      <StyledTextArea required={required} {...props} />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{
  maxWidth: number;
  maxWidthPx: number;
  marginRight: number;
  marginBottom: number;
}>`
  width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}%` : '100%;')};
  max-width: ${({ maxWidthPx }) => rem(maxWidthPx)};
  margin-bottom: ${({ marginBottom }) => rem(marginBottom)};
  margin-right: ${({ marginRight }) => rem(marginRight)};

  ${({ theme }) => theme.mediab.m580`
    &:last-child {
      margin-right: 0;
    }
  `}

  ${({ theme }) => theme.mediab.s450`
    max-width: initial;
  `}
`;

const StyledTextArea = styled(TextArea)`
  max-width: ${rem(688)};
  height: ${rem(144)};
  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(14)};
  `}
`;

const Label = styled(TextP)`
  font-size: ${rem(16)};
  margin-bottom: ${rem(4)};
  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(14)};
  `}
`;

const Required = styled.span`
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.stockCountUnavailable};
`;

export const FormWrapper = styled(FlexRowCenterVertical)<{
  maxWidth?: number;
  marginRight?: number;
}>`
  flex-flow: row wrap;
  margin-right: ${({ marginRight }) =>
    marginRight ? rem(marginRight) : rem(48)};
  max-width: ${({ maxWidth }) => (maxWidth ? rem(maxWidth) : rem(688))};
  width: 100%;

  &:last-child {
    margin-right: 0;
  }

  ${({ theme }) => theme.mediab.m580`
    margin-right: 0;
    max-width: initial;
    flex-flow: row;
  `}
`;

export { FormTextArea };
